import styled from "styled-components";
import { FlexContainer, InputsGridContainer } from "styled/Box";
import { Typography } from "styled/Typography";
import { theme } from "theme";

export const IconContainer = styled(FlexContainer)`
  border-radius: 50%;
  background: ${theme.color.background.gray};
  padding: 8px;
`;

export const Title = styled(Typography.H2)`
  font-weight: ${theme.fontWeight.medium};
  text-align: center;
`;

export const Description = styled(Typography.Title)`
  font-weight: ${theme.fontWeight.regular};
  text-align: center;
`;

export const StyledGrid = styled(InputsGridContainer)`
  max-width: 400px;
  padding: 16px 0;

  @media (max-width: ${theme.breakpoints.m}) {
    justify-items: center;
  }
`;
